import { CONFERENCE, CONTACTS, ADDRESS, PARTNERS } from "@/data/content";
import Reveal from "@/components/Reveal";
import { Phone, Mail, MapPin, Globe, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" className="bg-ink text-white pt-24 sm:pt-32 pb-10 px-5 sm:px-8 lg:px-12 relative overflow-hidden">
      <div className="absolute -bottom-24 -right-24 w-[34rem] h-[34rem] bg-crimson/15 blur-[120px] rounded-full pointer-events-none" />

      <div className="relative max-w-7xl mx-auto">
        {/* Final CTA */}
        <Reveal>
          <div className="border-b border-white/15 pb-16 mb-16">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-6">Don't miss it</p>
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
              <h2 className="font-heading text-5xl sm:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.9]">
                Register<br />Now.
              </h2>
              <button
                onClick={() => document.querySelector("#register")?.scrollIntoView({ behavior: "smooth" })}
                data-testid="footer-register-btn"
                className="bg-crimson text-white font-semibold px-8 py-5 flex items-center gap-2 hover:bg-white hover:text-ink transition-colors group text-lg w-fit"
              >
                Secure your seat <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <h3 className="font-heading text-2xl font-semibold tracking-tight mb-5">Contact</h3>
            <p className="text-white/60 text-sm leading-relaxed flex items-start gap-3 mb-6">
              <MapPin size={18} className="text-crimson shrink-0 mt-0.5" /> {ADDRESS}
            </p>
            <a href={`mailto:${CONFERENCE.email}`} data-testid="footer-email" className="flex items-center gap-3 text-white/80 hover:text-crimson transition-colors mb-3">
              <Mail size={18} className="text-crimson" /> {CONFERENCE.email}
            </a>
            <a href={CONFERENCE.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-crimson transition-colors">
              <Globe size={18} className="text-crimson" /> kalasalingam.ac.in/site/bioinnovate
            </a>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-2xl font-semibold tracking-tight mb-5">Queries</h3>
            <ul className="space-y-4">
              {CONTACTS.map((c) => (
                <li key={c.name}>
                  <a href={`tel:${c.tel}`} className="group flex items-start gap-3 hover:text-crimson transition-colors" data-testid={`contact-${c.tel}`}>
                    <Phone size={16} className="text-crimson shrink-0 mt-1" />
                    <span>
                      <span className="block text-white/90 text-[15px] font-medium">{c.name}</span>
                      <span className="block font-mono text-xs text-white/55 group-hover:text-crimson">{c.phone}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-2xl font-semibold tracking-tight mb-5">Partners</h3>
            <div className="flex flex-wrap gap-2">
              {PARTNERS.map((p) => (
                <span key={p} className="font-mono text-[10px] uppercase tracking-wider text-white/70 border border-white/25 px-3 py-1.5">
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <p className="font-heading text-lg font-bold">BioInnovate <span className="text-crimson font-mono text-sm">'26</span></p>
            <div className="flex items-center gap-5 mt-4 mb-3">
              <img
                src="/brand/blude-lifescience.png"
                alt="Blude Life Science and Tech"
                className="h-14 w-auto object-contain"
                data-testid="footer-blude-lifescience-logo"
              />
              <img
                src="/brand/blude-techx.png"
                alt="Blude TechX"
                className="h-9 w-auto object-contain"
                data-testid="footer-blude-techx-logo"
              />
            </div>
            <p className="text-white/40 text-xs mt-1 max-w-xl leading-relaxed">
              Curated by Blude companies. Blude Life Science & Tech LLP and Blude TechX, Madurai. Hosted by KARE (School of Bio, Chemical & Process Engineering) and Arizona State University, USA, in association with IAAM.
            </p>
          </div>
          <p className="font-mono text-[11px] text-white/40">© 2026 BioInnovate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
